<template>
  <div v-if="!isEmpty" v-bind:class="styleClass">
    <a v-if="images && images.length" v-bind:href="value.link" :class="imageClass">
      <picture>
        <source v-for="(image, i) in images" :key="i" :srcset="getSrcset(image)" :media="getMedia(image)"/>
        <img :src="getDefaultImageSrc(images)" loading="lazy"/>
      </picture>
    </a>
    <div :class="textClass">
      <div>
        <div v-if="value.breaking" class="breaking-tag-container">
          <i class="breaking-tag">
            <img :src="contextPath + '/binary/breaking-black.svg'" loading="lazy"/>{{ bundle.id_11436 }}
          </i>
        </div>
        <div v-if="value.advertorial && !fromTopicPage">
          <i class="advertorialClass">
            {{ bundle.id_10942 }}
          </i>
        </div>
        <div v-if="value.topic && !fromTopicPage">
          <i class="topic">
            {{ value.topicName }}
          </i>
        </div>
        <div v-if="value.company">
          <i class="company">
            {{ value.companyName }}
          </i>
        </div>
        <div v-if="value.otherHost">
          <i class="host">
            {{ value.otherHostName }}
          </i>
        </div>
        <div v-if="value.locked">
          <i class="locked">
            <i class="fa-light fa-lock"/>{{ bundle.id_10860 }}
          </i>
        </div>
        <div>
          <bookmark-button :type="type" :value="value.id" class="bookmark"/>
        </div>
      </div>
      <tracker a="impression" :tn="type" :tr="value.id">
        <a v-bind:href="value.link">
          <component :is="headingTag">
            <strong v-if="value.title.prefix">{{ value.title.prefix }}</strong>{{ value.title.subtitle }}
          </component>
        </a>
      </tracker>
<!--        <i v-if="value.playable" class="playable">-->
<!--          <i></i>-->
<!--        </i>-->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Track from "../plugins/track"
import BookmarkButton from "@/components/bookmark-button.vue";
Vue.use(Track)
export default {
  name: "front-page-article",
  components: {BookmarkButton},
  props: {
    id: {
      type: String
    },
    value: {
      type: Object
    },
    type: {
      type: String,
      required: true,
      validator: function (value) {
        return ["article", "announcement", "machine", "product", "competence", "job", "course"].indexOf(value) !== -1
      }
    },
    fromTopicPage: {
      type: Boolean
    },
    headlineTag: {
      type: Number
    },
    xsImagePosition: {
      type: String
    },
    xsImageSize: {
      type: String
    },
    xsTextSize: {
      type: String
    },
    smImagePosition: {
      type: String
    },
    smImageSize: {
      type: String
    },
    smTextSize: {
      type: String
    },
    mdImagePosition: {
      type: String
    },
    mdImageSize: {
      type: String
    },
    mdTextSize: {
      type: String
    },
    lgImagePosition: {
      type: String
    },
    lgImageSize: {
      type: String
    },
    lgTextSize: {
      type: String
    },
    xlImagePosition: {
      type: String
    },
    xlImageSize: {
      type: String
    },
    xlTextSize: {
      type: String
    },
    xxlImagePosition: {
      type: String
    },
    xxlImageSize: {
      type: String
    },
    xxlTextSize: {
      type: String
    }
  },
  data: function () {
    return {
      bundle: {
        id_11436: "BREAKING",
        id_10860: "Plus",
        id_10942: "Sponsored content"
      },
      contextPath: window.contextPath
    };
  },
  created: function () {
    var instance = this;
    Vue.$bundle("portal", instance.bundle, function (bundle) {
      instance.bundle = bundle;
    });
  },
  computed: {
    isEmpty: function () {
      return !this.value || this.value.length === 0;
    },
    styleClass: function () {
      const result = ["row", "gx-3", "gx-md-4", "fp-article"];

      const addImagePositionClass = (size, position) => {
        if (!position) {
          return;
        }
        switch (position) {
          case "top":
            result.push(size == "xs" ? "fp-top" : "fp-" + size + "-top");
            break;
          case "left":
            result.push(size == "xs" ? "fp-left" : "fp-" + size + "-left");
            break;
          default:
            result.push(size == "xs" ? "fp-none" : "fp-" + size + "-none");
            break;
        }
      }
      addImagePositionClass("xs", this.xsImagePosition);
      addImagePositionClass("sm", this.smImagePosition);
      addImagePositionClass("md", this.mdImagePosition);
      addImagePositionClass("lg", this.lgImagePosition);
      addImagePositionClass("xl", this.xlImagePosition);
      addImagePositionClass("xxl", this.xxlImagePosition);

      const addTextSizeClass = (size, type) => {
        if (!type) {
          return;
        }
        switch (type) {
          case "1":
            result.push(size == "xs" ? "fp-h1" : "fp-" + size + "-h1");
            break;
          case "2":
            result.push(size == "xs" ? "fp-h2" : "fp-" + size + "-h2");
            break;
          case "3":
            result.push(size == "xs" ? "fp-h3" : "fp-" + size + "-h3");
            break;
          case "4":
            result.push(size == "xs" ? "fp-h4" : "fp-" + size + "-h4");
            break;
          case "5":
            result.push(size == "xs" ? "fp-h5" : "fp-" + size + "-h5");
            break;
          default:
            result.push(size == "xs" ? "fp-h6" : "fp-" + size + "-h6");
            break;
        }
      }
      addTextSizeClass("xs", this.xsTextSize);
      addTextSizeClass("sm", this.smTextSize);
      addTextSizeClass("md", this.mdTextSize);
      addTextSizeClass("lg", this.lgTextSize);
      addTextSizeClass("xl", this.xlTextSize);
      addTextSizeClass("xxl", this.xxlTextSize);

      if (this.value.highlight) {
        result.push("fp-highlight");
      }
      return result.join(" ");
    },
    imageClass: function () {
      const result = ["fp-article-img"];

      const addColClass = (size, imagePosition, imageSize) => {
        if (imagePosition !== "left" || !imageSize) {
          return;
        }
        switch (imageSize) {
          case "12x":
            result.push(size === "xs" ? "col-12" : "col-" + size + "-12");
            break;
          case "8x":
            result.push(size === "xs" ? "col-8" : "col-" + size + "-8");
            break;
          case "6x":
            result.push(size === "xs" ? "col-6" : "col-" + size + "-6");
            break;
          case "4x":
            result.push(size === "xs" ? "col-4" : "col-" + size + "-4");
            break;
          case "3x":
            result.push(size === "xs" ? "col-3" : "col-" + size + "-3");
            break;
          default:
            result.push(size === "xs" ? "col-2" : "col-" + size + "-2");
            break;
        }
      }
      addColClass("xs", this.xsImagePosition, this.xsImageSize);
      addColClass("sm", this.smImagePosition, this.smImageSize);
      addColClass("md", this.mdImagePosition, this.mdImageSize);
      addColClass("lg", this.lgImagePosition, this.lgImageSize);
      addColClass("xl", this.xlImagePosition, this.xlImageSize);
      addColClass("xxl", this.xxlImagePosition, this.xxlImageSize);

      return result.join(" ");
    },
    textClass: function () {
      const result = [];

      const addColClass = (size, imagePosition) => {
        if (imagePosition !== "left") {
          return;
        }
        result.push(size === "xs" ? "col" : "col-" + size);
      }
      addColClass("xs", this.xsImagePosition);
      addColClass("sm", this.smImagePosition);
      addColClass("md", this.mdImagePosition);
      addColClass("lg", this.lgImagePosition);
      addColClass("xl", this.xlImagePosition);
      addColClass("xxl", this.xxlImagePosition);

      return result.join(" ");
    },
    headingTag: function () {
      let tag = this.headlineTag;
      if (!tag || tag < 1 || tag > 6) {
        tag = 6;
      }
      return "h" + tag;
    },
    images: function () {
      const result = [];
      if (this.value.images) {
        for (let i = 0; i < this.mediaSizes.order.length; i++) {
          const mediaSize = this.mediaSizes.order[i];
          const imageSizeKey = this.getImageSize(mediaSize.designation);
          const images = this.value.images[imageSizeKey];
          if (images) {
            for (let j = 0; j < images.length; j++) {
              const image = images[j];
              if (image.mediaSize.designation === mediaSize.designation) {
                result.push(image);
              }
            }
          }
        }
        // Set max width of each image to min width of the next image (minus the max width reduction value).
        for (let i = 0; i < result.length; i++) {
          if (result.length > i + 1) {
            const next = result[i + 1];
            result[i].mediaSize.maxWidth = next.mediaSize.minWidth - this.mediaSizes.maxWidthReduction;
          }
        }
      }
      return result;
    },
  },
  methods: {
    getImageSize: function (designation) {
      if (designation === this.mediaSizes.xs.designation) {
        return this.xsImageSize;
      } else if (designation === this.mediaSizes.sm.designation) {
        return this.smImageSize || this.xsImageSize;
      } else if (designation === this.mediaSizes.md.designation) {
        return this.mdImageSize || this.smImageSize || this.xsImageSize;
      } else if (designation === this.mediaSizes.lg.designation) {
        return this.lgImageSize || this.mdImageSize || this.smImageSize || this.xsImageSize;
      } else if (designation === this.mediaSizes.xl.designation) {
        return this.xlImageSize || this.lgImageSize || this.mdImageSize || this.smImageSize || this.xsImageSize;
      } else if (designation === this.mediaSizes.xxl.designation) {
        return this.xxlImageSize || this.xlImageSize || this.lgImageSize || this.mdImageSize || this.smImageSize || this.xsImageSize;
      } else {
        return null;
      }
    },
    getSrcset: function (image) {
      return Vue.$images.getSrcset(image);
    },
    getMedia: function (image) {
      return Vue.$images.getMedia(image);
    },
    getDefaultImageSrc: function (images) {
      return Vue.$images.getDefaultImageSrc(images);
    }
  }
}
</script>
